var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhiaName({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 10,
    viewBox: "0 0 33 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.76465 6.45215H2.22852V4.85254H4.76465C5.15658 4.85254 5.47559 4.78874 5.72168 4.66113C5.96777 4.52897 6.14779 4.34668 6.26172 4.11426C6.37565 3.88184 6.43262 3.61979 6.43262 3.32812C6.43262 3.0319 6.37565 2.75618 6.26172 2.50098C6.14779 2.24577 5.96777 2.04069 5.72168 1.88574C5.47559 1.73079 5.15658 1.65332 4.76465 1.65332H2.93945V10H0.888672V0.046875H4.76465C5.54395 0.046875 6.21159 0.188151 6.76758 0.470703C7.32812 0.748698 7.75651 1.13379 8.05273 1.62598C8.34896 2.11816 8.49707 2.68099 8.49707 3.31445C8.49707 3.95703 8.34896 4.51302 8.05273 4.98242C7.75651 5.45182 7.32812 5.81413 6.76758 6.06934C6.21159 6.32454 5.54395 6.45215 4.76465 6.45215ZM16.5498 4.10059V5.7002H11.3545V4.10059H16.5498ZM11.9629 0.046875V10H9.91211V0.046875H11.9629ZM18.0127 0.046875V10H15.9688V0.046875H18.0127ZM21.9775 0.046875V10H19.9336V0.046875H21.9775Z",
    fill: "#111111"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9453 1.74902L25.2383 10H23.0576L26.7559 0.046875H28.1436L27.9453 1.74902ZM30.1943 10L27.4805 1.74902L27.2617 0.046875H28.6631L32.3818 10H30.1943ZM30.0713 6.29492V7.90137H24.8145V6.29492H30.0713Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhiaName);
export default __webpack_public_path__ + "static/media/phia-name.fed977aabf39d40a5a1c2d95dbb50750.svg";
export { ForwardRef as ReactComponent };